import React from 'react';
import { Menu } from 'primereact/menu';

import GlobalTooltip from 'components/GlobalTooltip';
import { useMenuIconItems } from 'modules/FileManagerV2/hooks/ui/useMenuIconItems';

function MenuIcon({ item, index, itemsRef, onDownloadComplete }) {
  const { getItemsOption, deletePermission } = useMenuIconItems({ onDownloadComplete });

  const menuItems = getItemsOption(item)?.filter((menuItem) => menuItem.show && (deletePermission || menuItem.label !== 'Delete'));

  return (
    <>
      <Menu model={menuItems} popup id="popup_menu" ref={itemsRef[index]} />

      <span role="button" onClick={(event) => itemsRef[index]?.current?.toggle(event)}>
        <GlobalTooltip tooltip="More" position="top">
          <i className="icon-more d-inline-block rotate-90 text-primary-main" aria-hidden="true" aria-controls="popup_menu" aria-haspopup />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default MenuIcon;
